import { AfterViewInit, Directive, OnDestroy } from '@angular/core';
import { FlexibleConnectedPositionStrategy } from '@angular/cdk/overlay';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'mat-select[forcePanelDown]',
  standalone: true
})
export class ForcePanelDownDirective implements AfterViewInit, OnDestroy {
  private openedSub?: Subscription;

  constructor(private readonly matSelect: MatSelect) {}

  ngAfterViewInit(): void {
    this.openedSub = this.matSelect.openedChange.subscribe((opened) => {
      if (!opened) {
        return;
      }

      const overlayDir = (this.matSelect as unknown as { _overlayDir?: { overlayRef?: any } })._overlayDir;
      const overlayRef = overlayDir?.overlayRef;
      const positionStrategy = overlayRef?.getConfig?.().positionStrategy as FlexibleConnectedPositionStrategy | undefined;

      if (!positionStrategy) {
        return;
      }

      positionStrategy.withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
          offsetY: 8
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
          offsetY: 8
        }
      ]);

      overlayRef.updatePosition();
    });
  }

  ngOnDestroy(): void {
    this.openedSub?.unsubscribe();
  }
}
